<template>
  <footer class="bg-dark text-light py-3 mt-5">
    <div class="container-fluid">
      <div class="text-center">
        <p class="mb-0">{{ $t('footer.copyright') }}</p>
      </div>
    </div>
  </footer>
</template>

<script setup>
// Footer component
</script>

<style scoped>
footer {
  margin-top: auto;
}
</style>